module.exports = __webpack_public_path__ + "img/c1.15b0150f.png";